/* eslint-disable linebreak-style */
import successHandler from './successHandler';

const interceptor = response => successHandler(response);

export default interceptor;
